module.exports = __webpack_public_path__ + "static/media/test17_1.e4424918.png";